// extracted by mini-css-extract-plugin
export var container = "notifications-module--container--f7acb";
export var header = "notifications-module--header--25983";
export var list = "notifications-module--list--2d34c";
export var listBox = "notifications-module--list-box--ed0b2";
export var listItem = "notifications-module--list-item--1d89f";
export var newAvailableButton = "notifications-module--new-available-button--3572f";
export var newAvailableMessage = "notifications-module--new-available-message--c4e5d";